module.exports = __webpack_public_path__ + "media/images/elements/Elemntas-de0885083b24a3448fa809f6c4f8247d.svg";